import Markdown from 'react-markdown';
import React from 'react';
import { graphql } from 'gatsby';
import Overlay from '../components/Overlay';
import SEO from '../components/seo';

function ExhibitionPage(props) {
  const { data: { allMarkdownRemark: { edges: [data] } } } = props;
  const { node: { frontmatter: { exhibitions } } } = data;

  return (
    <Overlay title="Shows">
      <SEO title="Shows" />
      <Markdown source={exhibitions} />
    </Overlay>
  );
}

export default ExhibitionPage;

export const pageQuery = graphql`
    query Exhibition {
        allMarkdownRemark(
            filter: { frontmatter: { templateKey: { eq: "exhibition" } } }
        ) {
            edges {
                node {
                    id
                    fields {
                        slug
                    }
                    frontmatter {
                        exhibitions
                    }
                }
            }
        }
    }
`;
